import { render } from "./SectionTitleBarnett.vue?vue&type=template&id=44d8323d"
import script from "./SectionTitleBarnett.vue?vue&type=script&lang=js"
export * from "./SectionTitleBarnett.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__